<template>
  <div v-if="hostFilter && hostFilter.categories" class="ypo-event-host">
      <v-layout column wrap v-for="(hostCategory, idx) in hostFilter.categories" :key="idx">
      <v-flex xs12 ml-3 class="filter-category">
        <label class="check-container ypo_blue_color">
          <v-layout>
            <v-flex class="check-container--label"
                    :data-qe-id="`host-facet_option-${idx}`">
              <span :class="[hostCategory.checked ? 'checked-option' : '']">
                {{hostCategory.label}}</span>  
            </v-flex> 
          </v-layout>
          <input type="checkbox"
                :value="hostCategory"
                v-model="localFilters"
                :data-qe-id="`host-facet_option-${idx}_input`"
                @change="applyFilter(hostCategory, hostCategory.filterKey)">
          <span class="checkmark" :class="[hostCategory.checked ? 'checked-checkbox' : '']"></span>
        </label>
        <div  v-if="hostCategory.checked && hostCategory.subFilters && hostCategory.subFilters.length">
          <v-layout 
            column
            wrap 
            v-for="(hostSubCategory, subIdx) in hostCategory.subFilters" :key="subIdx">
            <v-flex xs12 class="ypo-event-host__subFilter sub-filter-layout" >
              <label class="check-container check-container--radio">
                <v-flex xs12 class="ypo-event-host__subFilter" v-if="!hostSubCategory.isTypeAhead">
                  <v-layout>
                    <v-flex
                      class="check-container--label"
                      :data-qe-id="`host-facet_option-${idx}_subFilter-${subIdx}`"> 
                      <span slot="label" :class="[hostSubCategory.checked ? 'checked-option' : '']">
                          {{hostSubCategory.label}}</span>
                    </v-flex>
                  </v-layout>
                </v-flex>
                  <v-flex xs12 class="ypo-event-host__subFilter" v-else-if="hostCategory.filterKey === ypoEventConstant.constant.keys.regionsDropDown">
                    <v-select 
                      class="ypo-event-host__subFilter--selections"
                      id="ypo-event-host_regions"
                      item-text="name"
                      v-model="selectedRegion"
                      :items="regionList"
                      :placeholder="selectedRegion.label"
                      @change="applyRegionDropDown(hostSubCategory,  hostCategory.filterKey)"
                      attach
                      dense
                      return-object>
                    </v-select>
                  </v-flex>
                <v-flex xs12 class="ypo-event-host__subFilter" v-else>  
                  <v-layout>
                      <v-flex
                      class="host-type-ahead"
                      :data-qe-id="`host-facet_option-${idx}_subFilter-${subIdx}`"> 
                      <ypo-event-type-ahead
                        :type-ahead-key="hostCategory"
                        :handle-selected-filter="applyFilter"
                        :applied-host-filters="appliedHostFilters"
                      > </ypo-event-type-ahead>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <input
                  class="ypo-event-host__subFilter--option"
                  v-model="localSubFilters"
                  type="radio"
                  :value="hostSubCategory"  
                  :name="hostCategory.filterKey"
                  @change="applyFilter(hostSubCategory,  hostCategory.filterKey)"               
                  :data-qe-id="`host-facet_option-${idx}_subFilter-${subIdx}_input`">
                <span class="checkmark" :class="[hostSubCategory.checked ? 'checked-checkbox' : '']"></span>
              </label>
            </v-flex>
          </v-layout>
        </div>  
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {
  ypoEventConstant,
  getUpdatedFiltersBasedOnHost,
  getFilteredString
} from "@/components/YpoEvents/ypoEvents.constant";
import YpoEventTypeAhead from "@/components/YpoEvents/YpoEventTypeAhead";
import { mapActions, mapGetters, mapState } from "vuex";
import { storeAction } from "@/store/storeActions.constant";
import { storeGetters } from "@/store/storeGetters.constant";
import {gaDataLayerEvent} from "@/plugins/analytics";
import {gtmEventName} from "@/plugins/gtmAnalytics";

export default {
  name: 'YpoEventsHostFilter',
  components: {
    YpoEventTypeAhead,
  },
  props: {
    hostFilter: {
      type: Object,
      required: true,
    },    
    allAppliedFilters: {
      type: Object,
    },
    appliedHostFilters: {
      type: Array,
      required: true,
      default: () => [],
    },
    setMostRecentFacetInState: {
      type: Function,
      required: true,
    },
  }, 
  created() {
    this.getYpoEventsRegionsList();
    this.setHostRegionFiltersState();
  },
  data() {
    return {
      ypoEventConstant,
      localFilters: [],
      localSubFilters: [],
      selectedRegion: { ...ypoEventConstant.hostFilterDefaults.regionDropDownDefault },
    };
  },
  methods: {  
    ...mapActions({
      getYpoEventsRegionsList: `ypoEvents/${storeAction.getYpoEventsRegionsList}`,
    }),
    applyFilter(filterItem, parentKey) {      
      const filterToPush = getUpdatedFiltersBasedOnHost(
          filterItem, 
          this.appliedHostFilters,        
          this.allAppliedFilters,
          parentKey,
        );
      if (this.setMostRecentFacetInState) this.setMostRecentFacetInState(ypoEventConstant.constant.keys.hostFilter);
      const gtmFilters = getFilteredString(filterToPush) ;
      gaDataLayerEvent(gtmEventName.C_Event_Search_Filters, gtmFilters);
      this.$router.push({
        query: {
          ...this.$route.query,
          eventFilters: JSON.stringify(filterToPush),
        },
      });
    }, 
    applyRegionDropDown(filterItem, parentKey) {
      const { selectedRegion } = this;
      if (selectedRegion && selectedRegion.searchFilterValue && filterItem && filterItem.filterKey
          && this.appliedHostFilters
          && !this.appliedHostFilters.find(filter => filter.filterValue
                  && filter.filterValue.toLowerCase() === selectedRegion.searchFilterValue.toLowerCase())) {
                const newRegionFilter = {
                  filterKey: filterItem.filterKey,
                  filterValue: selectedRegion.searchFilterValue,
                  isTypeAhead: filterItem.isTypeAhead,
                  ribbonGroupName: filterItem.ribbonGroupName,
                  label: selectedRegion.searchFilterValue,
                };    
                    
        this.applyFilter(newRegionFilter, parentKey);
      }
    },
    setHostRegionFiltersState() {
      if (this.appliedHostFilters && this.appliedHostFilters.length && this.hostFilter) {       
        let regionList = { ...ypoEventConstant.hostFilterDefaults.regionDropDownDefault };        
        const previouslySelectedRegions = this.appliedHostFilters.find((item) => {
            return item.filterKey && item.filterValue
                && item.filterKey.toLowerCase() === ypoEventConstant.constant.keys.regionsDropDown.toLowerCase()
                && item.isTypeAhead;
        });
        if (previouslySelectedRegions && previouslySelectedRegions.filterValue) {
            regionList = {
               filterValue: previouslySelectedRegions.filterValue,
               label: previouslySelectedRegions.filterValue,
               parentKey: previouslySelectedRegions.filterKey,
            };
        this.selectedRegion = regionList;
      }
      return this.selectedRegion;
      }
    },
},
computed: {
    ...mapState('actionState', ['actions']),
    ...mapGetters({
      ypoEventsRegionsList: `ypoEvents/${storeGetters.ypoEventsRegionsList}`, 
    }),
    regionList() {    
      return this.ypoEventsRegionsList ? this.ypoEventsRegionsList : [];
    },        
},
};
</script>

<style lang="scss" scoped>
@import '../../common/styles/_colors.scss';
@import '../../common/styles/_responsive.scss';
@import '../../common/styles/_commonClasses.scss';

.ypo-event-host {
  .filter-category {
    @extend %ypo-secondary-checkbox;
  }

  
  &__subFilter{
    @extend %ypo-secondary-checkbox;
    &--selections {
    font-size: 12px !important;
    padding-top: 0;
    margin-top: 0;

    .v-select__selection {
      margin: 0 !important;
    }
  }
  }
}

</style>
<style lang="scss">
@import '../../common/styles/_colors.scss';
@import '../../common/styles/_responsive.scss';
@import '../../common/styles/_commonClasses.scss';

.ypo-event-host {
  &__subFilter--selections {
    .v-input__slot {
      height: 20px !important;
      padding-left: 5px !important;
    }

    .v-input__append-inner {
      margin-top: 0 !important;
    }
  }

  .sub-filter-layout {
    margin-left: 18px;
  }

  .v-select__selection--comma {
    margin-bottom: 0 !important;
    margin-left: 5px !important;
    text-transform: capitalize!important;
  }

  .theme--light.v-text-field.v-input--is-disabled > .v-input__control > .v-input__slot:before {
    border-image: none !important;
  }

  .v-select.v-text-field input {
    padding: 0 !important;
  }

  .v-menu__content {
    @extend %inner-scrollbar;
  }

  .v-list__tile {
    text-transform: capitalize;
  }
    &__sort {
    line-height: 17px;
    :hover{
        text-decoration: underline;        
        transition-property: all;
        transition-duration: 200ms;  
        color: $ypo-cod-gray !important;
      }   
      .checkmark {
      border: 1px solid #111111 !important;
      box-shadow: inset 1px 1px 3px 0 rgba(0,0,0,0.3) !important;
      &::after {
        border: none !important;
        -webkit-transform: none !important;
        transform: none !important;
        background-color: $ypo-cod-gray !important;
      }  
    }   
  }
}
</style>
